import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useLayoutEffect } from 'react';
import { LoaderFunctionArgs, useLoaderData, useNavigate, useParams } from 'react-router-dom';
import { fetchLogbookConfigurationDetails } from './api/listApi';
import { OCRMainContainer } from './components/containers/OCRMainContainer';
import { useOCRStore } from './store/ocrStore';

export const logbookConfigurationLoader = async (args: LoaderFunctionArgs) => {
    const { params } = args;
    const logbookAssetConfigurationId = params?.logbookAssetConfigurationId;

    if (!logbookAssetConfigurationId) {
        return null;
    }

    try {
        const response = await fetchLogbookConfigurationDetails(logbookAssetConfigurationId);
        return response;
    } catch (error) {
        console.error("Failed to load logbook configuration details:", error);
        return null;
    }
};

export const LogbookConfigurationPage: React.FC = () => {
    const { logbookAssetConfigurationId, plantId } = useParams<{ logbookAssetConfigurationId: string; plantId: string }>();
    const loaderData = useLoaderData();
    const navigate = useNavigate();
    
    const { selectedTemplate, populateStateForEdit, resetAll } = useOCRStore(state => ({
        selectedTemplate: state.selectedTemplate,
        populateStateForEdit: state.populateStateForEdit,
        resetAll: state.resetAll,
    }));

    const isEditMode = !!logbookAssetConfigurationId;

    useLayoutEffect(() => {
        if (isEditMode) {
            if (loaderData) {
                populateStateForEdit(loaderData);
            } else {
                navigate(`/logbooks/${plantId}`, { replace: true });
            }
        }

        return () => {
            resetAll();
        };
    }, [isEditMode, loaderData, navigate, populateStateForEdit, resetAll, plantId]);

    if (isEditMode && !selectedTemplate) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="80vh">
                <CircularProgress />
                <Typography sx={{ ml: 2 }}>Loading Configuration...</Typography>
            </Box>
        );
    }

    return <OCRMainContainer isEditMode={isEditMode} />;
};